/**
 * Validate an untrusted redirect target (typically from a `?redirect_to=` or
 * `?next=` query param) and return either the original path or a safe fallback.
 *
 * Accepts only same-origin paths — strings that begin with a single `/` and
 * are not protocol-relative (`//evil.com`). Anything else (absolute URLs,
 * non-string values, missing leading slash, empty string) returns `fallback`.
 *
 * Pure function, no Vue/Nuxt imports — auto-imported by Nuxt from `app/utils/`.
 */
export function safePath(value: unknown, fallback = '/dashboard'): string {
  if (typeof value !== 'string') return fallback;
  if (!value.startsWith('/')) return fallback;
  if (value.startsWith('//')) return fallback;
  return value;
}
